/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdjustPolicyBody } from '../models/AdjustPolicyBody';
import type { BillingPeriod } from '../models/BillingPeriod';
import type { BindPolicyBody } from '../models/BindPolicyBody';
import type { BordereauEntry } from '../models/BordereauEntry';
import type { CancelPolicyBody } from '../models/CancelPolicyBody';
import type { ChangePolicyDistributionBody } from '../models/ChangePolicyDistributionBody';
import type { ChangePolicyInsuredBody } from '../models/ChangePolicyInsuredBody';
import type { ConfigurePolicyMetaBody } from '../models/ConfigurePolicyMetaBody';
import type { ConvertPolicyToDistributedBody } from '../models/ConvertPolicyToDistributedBody';
import type { CreateRenewalQuoteBody } from '../models/CreateRenewalQuoteBody';
import type { Document } from '../models/Document';
import type { LapsePolicyBody } from '../models/LapsePolicyBody';
import type { Partner } from '../models/Partner';
import type { Policy } from '../models/Policy';
import type { PolicyDocumentLink } from '../models/PolicyDocumentLink';
import type { Premium_2 } from '../models/Premium_2';
import type { RebateCalculationPeriod } from '../models/RebateCalculationPeriod';
import type { RebateV2 } from '../models/RebateV2';
import type { RebateV2Calculation } from '../models/RebateV2Calculation';
import type { RebateV2Period } from '../models/RebateV2Period';
import type { Schedule } from '../models/Schedule';
import type { TransferPolicyAgencyBody } from '../models/TransferPolicyAgencyBody';
import type { TSP } from '../models/TSP';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PoliciesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns any Premium objects for a given policy
   * @throws ApiError
   */
  public invoiceTotals({
    id,
  }: {
    id: string,
  }): CancelablePromise<{
    policyId: string;
    invoiced: Premium_2;
    collected: Premium_2;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/core/policies/{id}/invoice-totals',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns Partner The Partners
   * @throws ApiError
   */
  public policyDistributors({
    id,
  }: {
    id: string,
  }): CancelablePromise<Array<Partner>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/core/policies/{id}/distributors',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns BillingPeriod The Billing Periods
   * @throws ApiError
   */
  public policyBillingPeriods({
    id,
  }: {
    id: string,
  }): CancelablePromise<Array<BillingPeriod>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/core/policies/{id}/billing-periods',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns PolicyDocumentLink A list of links to policy documents
   * @throws ApiError
   */
  public listPolicyDocuments({
    id,
  }: {
    id: string,
  }): CancelablePromise<Array<PolicyDocumentLink>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/policies/{id}/legacy-documents',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public changePolicyInsured({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Insured
     */
    requestBody: ChangePolicyInsuredBody,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/core/policies/{id}/change-insured',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public cancelPolicyCore({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Cancel
     */
    requestBody: CancelPolicyBody,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/core/policies/{id}/cancel',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public voidPolicyCore({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Void
     */
    requestBody?: any,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/core/policies/{id}/void',
      path: {
        'id': id,
      },
      body: requestBody,
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public changePolicyDistribution({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Insured
     */
    requestBody: ChangePolicyDistributionBody,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/core/policies/{id}/change-distribution',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public transferPolicyAgency({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Insured
     */
    requestBody: TransferPolicyAgencyBody,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/core/policies/{id}/transfer-agency',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns any The Documents
   * @throws ApiError
   */
  public findDocumentForAssociation({
    id,
    types,
    includeAllVersions,
    term,
    after,
    limit,
  }: {
    id: string,
    types?: string,
    includeAllVersions?: boolean,
    term?: string,
    after?: string,
    limit?: number,
  }): CancelablePromise<{
    /**
     * The documents that matched the criteria
     */
    items: Array<Document>;
    /**
     * The cursor to return the next set of documents
     */
    next: string | null;
    /**
     * The total number of documents matching the criteria
     */
    total: number;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/core/policies/{id}/documents',
      path: {
        'id': id,
      },
      query: {
        'types': types,
        'includeAllVersions': includeAllVersions,
        'term': term,
        'after': after,
        'limit': limit,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * Policy Bordereau Entries
   * @returns BordereauEntry OK
   * @throws ApiError
   */
  public policyBordereauEntries({
    id,
    from,
    to,
    fromReported,
    toReported,
  }: {
    id: string,
    from?: string,
    to?: string,
    fromReported?: string,
    toReported?: string,
  }): CancelablePromise<Array<BordereauEntry>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/core/policies/{id}/bordereau-entries',
      path: {
        'id': id,
      },
      query: {
        'from': from,
        'to': to,
        'fromReported': fromReported,
        'toReported': toReported,
      },
      errors: {
        400: `Malformed Error`,
      },
    });
  }

  /**
   * @returns any The Policies
   * @throws ApiError
   */
  public searchPolicies({
    search,
    customerId,
    brokerId,
    claimsAdminId,
    carrierId,
    status,
    after,
    limit,
    isActive,
    effectiveTime,
  }: {
    search?: string,
    customerId?: string,
    brokerId?: string,
    claimsAdminId?: string,
    carrierId?: string,
    status?: string,
    after?: string,
    limit?: number,
    isActive?: boolean,
    effectiveTime?: string,
  }): CancelablePromise<{
    total: number;
    next: string | null;
    items: Array<Policy>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/policies',
      query: {
        'search': search,
        'customerId': customerId,
        'brokerId': brokerId,
        'claimsAdminId': claimsAdminId,
        'carrierId': carrierId,
        'status': status,
        'after': after,
        'limit': limit,
        'isActive': isActive,
        'effectiveTime': effectiveTime,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public bindPolicy({
    requestBody,
  }: {
    /**
     * The Policy
     */
    requestBody: BindPolicyBody,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/motor/policies',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public findPolicy({
    id,
    effectiveTime,
  }: {
    id: string,
    effectiveTime?: string,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/policies/{id}',
      path: {
        'id': id,
      },
      query: {
        'effectiveTime': effectiveTime,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public adjustPolicy({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Adjustment
     */
    requestBody: AdjustPolicyBody,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/policies/{id}/adjust',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public cancelPolicy({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Cancel
     */
    requestBody: CancelPolicyBody,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/policies/{id}/cancel',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public voidPolicy({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Void
     */
    requestBody?: any,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/policies/{id}/void',
      path: {
        'id': id,
      },
      body: requestBody,
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public lapsePolicy({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Lapse
     */
    requestBody: LapsePolicyBody,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/policies/{id}/lapse',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public reinstatePolicy({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Reinstate
     */
    requestBody?: any,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/policies/{id}/reinstate',
      path: {
        'id': id,
      },
      body: requestBody,
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public billPolicy({
    id,
  }: {
    id: string,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/policies/{id}/bill',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Schedule The Schedules
   * @throws ApiError
   */
  public policySchedules({
    id,
  }: {
    id: string,
  }): CancelablePromise<Array<Schedule>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/policies/{id}/schedules',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public configurePolicy({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Policy Meta
     */
    requestBody: ConfigurePolicyMetaBody,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/policies/{id}/configure',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public convertToDistributed({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Conversion
     */
    requestBody: ConvertPolicyToDistributedBody,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/policies/{id}/convert-to-distributed',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public convertToBundled({
    id,
  }: {
    id: string,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/policies/{id}/convert-to-bundled',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Policy The Policy
   * @throws ApiError
   */
  public createRenewalQuote({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Body
     */
    requestBody: CreateRenewalQuoteBody,
  }): CancelablePromise<Policy> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/motor/policies/{id}/renewal-quotes',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns RebateCalculationPeriod Rebate Calculation Periods
   * @throws ApiError
   */
  public rebateCalculationPeriods({
    id,
    telemetryDb,
    version,
  }: {
    id: string,
    telemetryDb?: 'platform' | 'telemetry',
    version?: string,
  }): CancelablePromise<Array<RebateCalculationPeriod>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/policies/{id}/rebate-calculation-periods',
      path: {
        'id': id,
      },
      query: {
        'telemetryDb': telemetryDb,
        'version': version,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns RebateV2 Rebate V2
   * @throws ApiError
   */
  public findRebateV2({
    id,
  }: {
    id: string,
  }): CancelablePromise<RebateV2> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/policies/{id}/rebates-v2',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns RebateV2Period Rebate V2 Periods
   * @throws ApiError
   */
  public rebatePeriods({
    id,
    period,
    startTime,
    endTime,
  }: {
    id: string,
    period: string,
    startTime?: string,
    endTime?: string,
  }): CancelablePromise<Array<RebateV2Period>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/policies/{id}/rebates-v2/periods',
      path: {
        'id': id,
      },
      query: {
        'period': period,
        'startTime': startTime,
        'endTime': endTime,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns RebateV2Calculation Rebate V2 Calculations
   * @throws ApiError
   */
  public searchCalculations({
    id,
  }: {
    id: string,
  }): CancelablePromise<Array<RebateV2Calculation>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/policies/{id}/rebates-v2/calculations',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns TSP TSP Details
   * @throws ApiError
   */
  public findPolicyAssociations({
    id,
  }: {
    id: string,
  }): CancelablePromise<Array<TSP>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/policies/{id}/tsps',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public savePolicyAssociations({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The TSP IDs to add to the current policy
     */
    requestBody: {
      tspIds: Array<string>;
    },
  }): CancelablePromise<{
    message?: string;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/motor/policies/{id}/tsps',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns string Invalid Vrns
   * @throws ApiError
   */
  public getInvalidVrns({
    policyId,
  }: {
    policyId: string,
  }): CancelablePromise<Array<string>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/insights/{policyId}/invalid-vrns',
      path: {
        'policyId': policyId,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

}
